;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesRegenerationConfirm =  Marionette.ItemView.extend({
		template: JST.LeagueRegenerationConfirm,
		ui: {
			listLink:    	'#league_list',
			manageLink: 	'#manage_league'
		},
		initialize : function(){

			this.scrollToTop();
			this.league_id    	= this.getOption('league_id');
			this.from_id 	    = this.getOption('from_id');
			this.league        	= this.getOption('league');
			this.from_league	= this.getOption('from_league');
			this.user          	= this.getOption('user');
			this.getting_data  	= false;

			this.model.set({
				league:  {}
			});

			var complete = [
				this.league.show().fetch({ data:{ id: this.league_id } }),
				this.from_league.show_regenerate().fetch({ data:{ id: this.from_id } })
			];

			$.when.apply(null, complete).done(_.bind(this.initData, this));
		},
		initData: function() {
			//this.trigger('leagues:manage:menu', this.league);
			this.model.set({
				league:  this.league.toJSON()
			});

			this.render();

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));